module.exports = __webpack_public_path__ + "img/failed-icon.2214e001.png";